@if (invites && invites.length > 0) {
  @if (mode === 'mobile-inline') {
    <section class="invitation-inline-panel bg-base-100">
      <div class="flex justify-center pt-2">
        <div class="h-1.5 w-12 rounded-full bg-base-300"></div>
      </div>

      <div class="flex items-center justify-between gap-3 px-4 pb-3 pt-2">
        <div>
          <h3 class="font-semibold">Invitations</h3>
          <p class="text-sm text-base-content/60">{{ invites.length }} pending</p>
        </div>

        <button
          type="button"
          class="btn btn-ghost btn-sm btn-circle"
          aria-label="Collapse invitations"
          (click)="requestClose()"
        >
          ✕
        </button>
      </div>

      <div class="divider my-0"></div>

      <div class="max-h-[min(50dvh,32rem)] overflow-y-auto px-3 pb-[calc(env(safe-area-inset-bottom)+1rem)] pt-3">
        <ng-container [ngTemplateOutlet]="invitationList"></ng-container>
      </div>
    </section>
  } @else {
    <details class="dropdown dropdown-end block">
      <summary class="btn btn-ghost btn-square relative" aria-label="Invitations">
        <fa-icon [icon]="faInvitationIndicator"></fa-icon>

        <span class="badge badge-error badge-xs absolute -top-1 -right-1">
          {{ invites.length }}
        </span>

        <span class="sr-only">unread invitations</span>
      </summary>

      <div class="dropdown-content z-50 mt-2 w-96 max-w-[calc(100vw-2rem)]">
        <div class="card border border-base-300 bg-base-100 shadow">
          <div class="card-body p-3">
            <div class="flex items-center justify-between">
              <h3 class="font-semibold">Invitations</h3>
              <span class="text-sm text-base-content/60">{{ invites.length }}</span>
            </div>

            <div class="divider my-2"></div>

            <div class="max-h-96 overflow-auto">
              <ng-container [ngTemplateOutlet]="invitationList"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </details>
  }

  <ng-template #invitationList>
    <ul class="space-y-2">
      @for (i of invites; track i.id ?? $index) {
        <li class="p-0">
          <div class="flex flex-col gap-3 rounded-box border border-base-300 bg-base-100 p-3">
            <div class="flex items-start justify-between gap-4">
              <div>
                <div class="font-medium">{{ i.inviter?.email || 'Unknown sender' }}</div>
                <div class="text-sm text-base-content/70">
                  Invited you to join {{ i.household?.name || 'Household' }}
                </div>
              </div>
              <div class="whitespace-nowrap text-xs text-base-content/60">
                {{ i.invited_at | date: 'short' }}
              </div>
            </div>

            <div class="grid grid-cols-[auto,1fr] gap-x-3 gap-y-1 text-sm">
              <div class="text-base-content/60">Invitee</div>
              <div class="truncate">{{ i.invitee_email || 'You' }}</div>

              <div class="text-base-content/60">For</div>
              <div class="truncate">{{ i.household?.name || 'Household' }}</div>
            </div>

            <div class="flex flex-col gap-2 pt-1 sm:flex-row sm:justify-end">
              <ui-button
                [variant]="'danger'"
                size="sm"
                [fullWidthOnMobile]="mode === 'mobile-inline'"
                (clicked)="reject(i.id!)"
              >
                Decline
              </ui-button>

              <ui-button
                [variant]="'success'"
                size="sm"
                [fullWidthOnMobile]="mode === 'mobile-inline'"
                (clicked)="accept(i.id!)"
              >
                Accept
              </ui-button>
            </div>
          </div>
        </li>
      }
    </ul>
  </ng-template>
}
